import type { PricingMode } from '../../types/agreement'
import { hasRateCardSeed } from '../../lib/rateCardLineItems'

interface PricingPresentationFieldsProps {
  serviceType: string
  pricingMode: PricingMode | undefined
  onPricingModeChange: (mode: PricingMode) => void
  onSeedRateCard: () => void
  lineItemCount: number
}

export function PricingPresentationFields({
  serviceType,
  pricingMode,
  onPricingModeChange,
  onSeedRateCard,
  lineItemCount,
}: PricingPresentationFieldsProps) {
  const mode = pricingMode || 'total'
  const canSeed = hasRateCardSeed(serviceType)

  return (
    <div className="mb-4 p-4 bg-gray-50 rounded-lg border border-gray-200" data-consistency-anchor="pricing-presentation">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Pricing presentation</label>
          <select
            value={mode}
            onChange={(e) => onPricingModeChange(e.target.value as PricingMode)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="total">Totals (monthly / flat / project)</option>
            <option value="rate_card">Rate card (price list of rates)</option>
          </select>
          <p className="text-xs text-gray-500 mt-1">
            Rate card shows per-unit rates on the proposal or contract PDF. Use with actual-usage
            billing for turnovers and hourly work.
          </p>
        </div>
        {canSeed && (
          <div>
            <button
              type="button"
              onClick={onSeedRateCard}
              className="w-full px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm font-medium"
            >
              {lineItemCount > 0 ? 'Replace with rate card tiers' : 'Load rate card tiers'}
            </button>
            <p className="text-xs text-gray-500 mt-1">
              Seeds standard unit-size or hourly rates as variable line items.
            </p>
          </div>
        )}
      </div>
      {mode === 'rate_card' && (
        <p className="mt-3 text-xs text-indigo-700 bg-indigo-50 border border-indigo-100 rounded px-3 py-2">
          Rate card mode works best with billing method &quot;Actual usage&quot; — jobs bill at the rate for each unit size or hour worked.
        </p>
      )}
    </div>
  )
}
